import type { SVGProps } from 'react'
import * as React from 'react'

const finland24 = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M29.6034 26.4828H2.39656C1.07294 26.4828 0 25.4098 0 24.0862V7.91384C0 6.59027 1.07294 5.51727 2.39656 5.51727H29.6034C30.927 5.51727 32 6.59021 32 7.91384V24.0863C32 25.4098 30.9271 26.4828 29.6034 26.4828Z"
      fill="#F5F5F5"
    />
    <path d="M32 14.3448H13.2414V5.51727H9.93106V14.3448H0V17.6552H9.93106V26.4828H13.2414V17.6552H32V14.3448Z" fill="#41479B" />
  </svg>
)

export default finland24
